import { render, staticRenderFns } from "./ar_comprimido.vue?vue&type=template&id=6fead6d0"
import script from "./ar_comprimido.vue?vue&type=script&lang=js"
export * from "./ar_comprimido.vue?vue&type=script&lang=js"
import style0 from "./ar_comprimido.vue?vue&type=style&index=0&id=6fead6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports